import {
  COINNIK_MARKET_BLOG,
  COINNIK_MARKET_URL_BASE_TOKENS,
} from "configs/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CardTitle, Button, Row, Col } from "reactstrap";
import { tokens } from "store/reducers/tokenStore";
import { selectToken } from "store/selector/tokenStore";
import { getTokenInfo } from "utils/getters";

const CoinInformation = ({
  heroTitle,
  subTitle,
  content,
  coinHistory,
  historytext,
  btnTitle,
  linkTitle,
  props,
}: any) => {
  const { t } = useTranslation();
  const tokens = useSelector(selectToken);
  const [currentSymbol, setCurrentSymbol] = useState("");
  const currentCoinName = props.match.params.id;

  useEffect(() => {
    setCurrentSymbol(getTokenInfo(currentCoinName, "symbol", "", "name"));
  }, [props.match, tokens]);

  return (
    <>
      {heroTitle == "" ? (
        <></>
      ) : (
        <CardTitle className="pb-4">
          <h2>
            <span className="title-bordre-bottom fw-bold fs-5 text-secondary-two-light">
              {heroTitle}
            </span>
          </h2>
        </CardTitle>
      )}
      <h2 className=" fs-7">{subTitle}</h2>
      <p className="fs-6 text-secondary-two-light ">{content}</p>
      <span className=" fs-7">{coinHistory}</span>
      <p className="fs-6 text-secondary-two-light">{historytext}</p>
      <Row>
        {btnTitle == "" ? (
          <></>
        ) : (
          <Col xs="12" lg="3" xl="3" className="d-flex justify-content-center">
            <a href={`${COINNIK_MARKET_URL_BASE_TOKENS}${currentSymbol}_TMN`}>
              <Button color="warning" size="lg" className="fs-7 text-light ">
                {btnTitle}
              </Button>
            </a>
          </Col>
        )}
        <Col
          xs="12"
          lg="3"
          xl="3"
          className="d-flex justify-content-center align-items-center mt-3 mt-sm-0"
        >
          <a href={COINNIK_MARKET_BLOG} className="fs-7 text-warning-light">
            {linkTitle}
          </a>
        </Col>
      </Row>
    </>
  );
};
export default CoinInformation;
